<template>
  <div
    class="d-profile-badge text-center"
    :class="{
      'active': (allowSelection && badge.isAwarded),
      'awarded': badge.isAwarded,
      'selected': badge.isSelected,
    }"
    @click="selectBadge"
  >
    <img
      :alt="badge.name"
      :src="badge.imageUrl"
      :title="badge.name"
    >

    <p v-if="showName">
      {{ badge.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    allowSelection: {
      type: Boolean,
      default: false,
    },
    createdAt: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    isAwarded: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    showName: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    badge: {
      imageUrl: null,
      isAwarded: false,
      isSelected: false,
      name: null,
    },
  }),
  mounted() {
    this.initBadge();
  },
  methods: {
    initBadge() {
      this.$set(this, 'badge', {
        createdAt: this.createdAt || null,
        isAwarded: this.isAwarded,
        isSelected: false,
        imageUrl: this.imageUrl,
        name: this.name,
      });
    },

    selectBadge() {
      if (!this.allowSelection || !this.badge.isAwarded) {
        return;
      }

      this.$store.dispatch('ProfileBadges/selectBadge', this.badge);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-profile-badge {
  opacity: $disabled-opacity;
  pointer-events: none;

  @include transition((
    opacity
  ));

  &.awarded {
    opacity: 1;
    pointer-events: all;

    &.active {
      cursor: pointer;

      &.selected {
        img {
          border-color: getColor($yellow);
        }
      }
    }
  }

  img {
    border: $border-width-lg solid transparent;
    border-radius: 50%;
    margin: -$border-width-lg;

    @include transition((
      border-color
    ));
  }
}
</style>
